import React, { useState, useMemo } from 'react';
import IPLPTemplateForm, {
	IPLPTemplateFormValues,
} from '../IPLPTemplateForm/IPLPTemplateForm';
import Loading from '../../../../../Components/Loading';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import {
	IplpTemplate,
	useUpdateIplpTemplateMutation,
} from '../../../../../graphql/graphql';

interface Props {
	item: IplpTemplate;
	onUpdate: () => void;
}

const IPLPTemplateUpdate: React.FC<Props> = ({ item, onUpdate }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [updateIPLPTemplate] = useUpdateIplpTemplateMutation();
	const { displayGQLError } = useApiClient();

	const defaultValues: IPLPTemplateFormValues = useMemo(() => {
		return {
			name: item.name,
			manual: item.manual || undefined,
			dosage: item.dosage || undefined,
		};
	}, [item]);

	const handleSubmit = async (values: IPLPTemplateFormValues) => {
		setIsLoading(true);

		const response = await updateIPLPTemplate({
			where: {
				id: item.id,
			},
			input: values,
		});
		displayGQLError(response);

		if ('data' in response) {
			onUpdate();
		}

		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<IPLPTemplateForm onSubmit={handleSubmit} defaultValues={defaultValues} />
	);
};

export default IPLPTemplateUpdate;
